module.exports = __webpack_public_path__ + "media/images/SIF_header-45459f98b85db97550fdadac1d4e6f15.jpg";